import { z } from "zod";

export const OFF_SITE_DISTANCE_VALUES = ["near", "far"] as const;
export const OFF_SITE_DISTANCES = OFF_SITE_DISTANCE_VALUES;
export type OffSiteDistance = (typeof OFF_SITE_DISTANCE_VALUES)[number];

export type BookingLocationKind = "studio" | "off_site";

export const offSiteDistanceSchema = z.enum(OFF_SITE_DISTANCE_VALUES);

export const OFF_SITE_DISTANCE_SELECT_OPTIONS: ReadonlyArray<{
  value: OffSiteDistance;
  label: string;
}> = [
  { value: "near", label: "ໃກ້" },
  { value: "far", label: "ໄກ" },
];

export function normalizeOffSiteDistance(
  locationKind: BookingLocationKind,
  offSiteDistance: OffSiteDistance | null | undefined,
): OffSiteDistance | null {
  if (locationKind === "studio") {
    return null;
  }
  return offSiteDistance ?? "near";
}

export function assertOffSiteDistanceForLocation(
  locationKind: BookingLocationKind,
  offSiteDistance: OffSiteDistance | null,
): void {
  if (locationKind === "off_site" && offSiteDistance == null) {
    throw new Error("Off-site distance (near/far) is required for off-site bookings");
  }
  if (locationKind === "studio" && offSiteDistance != null) {
    throw new Error("Off-site distance must be null for studio bookings");
  }
}

export function offSiteDistanceShortLabel(
  distance: OffSiteDistance | null | undefined,
): string {
  if (distance === "far") return "ໄກ";
  if (distance === "near") return "ໃກ້";
  return "";
}

export function offSiteDistanceFullLabel(
  distance: OffSiteDistance | null | undefined,
): string {
  if (distance === "far") return "ນອກສະຖານທີ່ໄກ";
  if (distance === "near") return "ນອກສະຖານທີ່ໃກ້";
  return "ນອກສະຖານທີ່";
}
